module.exports = __webpack_public_path__ + "static/media/insta4.315a5307.png";